import {worldTypes} from './config';

const coverContentByWorldType = {
  [worldTypes.craterRun]: {
    browseLabel: 'BROWSE RACE ROOMS',
    createLabel: 'CREATE A RACE ROOM',
    publicListLabel: 'Public Race Rooms',
    goToWorldLabel: 'LET\'S RACE',
    title: 'Racing',
    subtitle: 'Fly fast. Beat the clock. Race solo or with other Clankers',
  },
  [worldTypes.spaceport]: {
    browseLabel: 'BROWSE SPACEPORTS',
    createLabel: 'CREATE A SPACEPORT',
    publicListLabel: 'Public Spaceports',
    goToWorldLabel: 'GO TO SPACEPORT',
    title: 'Spaceport',
    subtitle: 'Games, sports, battles & chaos. Hang out with friends',
  },
};

export const getCoverContent = (worldType) => (
  coverContentByWorldType[worldType] || coverContentByWorldType[worldTypes.spaceport]
);
